import { SendIcon } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import { Button } from '~/components/component-library'
import { SupportedChainId } from '~/constants/chains'
import { IAddress } from '~/types'

type SendButtonProps = {
  defaultSender?: IAddress
  defaultToken?: IAddress
  defaultChainId?: SupportedChainId
  defaultRecipients?: { address: IAddress; amount?: string }[]
  isOfframp?: boolean
  isDisabled?: boolean
  disabledReason?: string
} & (
  | { asChild: true; children: React.ReactNode }
  | { asChild?: false; children?: never }
)

export const buildSendQueryParams = ({
  defaultSender,
  defaultToken,
  defaultChainId,
  defaultRecipients,
  isOfframp = false,
}: SendButtonProps) => {
  const params = new URLSearchParams()

  if (defaultSender) {
    params.set('account', defaultSender)
  }
  if (defaultToken) {
    params.set('token', defaultToken)
  }
  if (defaultChainId) {
    params.set('chainId', defaultChainId.toString())
  }
  if (defaultRecipients && defaultRecipients.length > 0) {
    params.set('recipients', JSON.stringify(defaultRecipients))
  }
  if (isOfframp) {
    params.set('offramp', 'true')
  }

  const queryString = params.toString()
  return queryString ? `?${queryString}` : ''
}

export const SendButton = (props: SendButtonProps) => {
  const queryParams = buildSendQueryParams(props)

  return (
    <SplitsLink path={`/send${queryParams}`}>
      {props.asChild ? (
        props.children
      ) : (
        <Button
          variant="secondary"
          prefix={<SendIcon />}
          isDisabled={props.isDisabled}
          disabledReason={props.disabledReason}
        >
          Send
        </Button>
      )}
    </SplitsLink>
  )
}
